import React from 'react';
import classnames from 'classnames';
import { PapiDeviation } from '@wix/da-papi-types';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { useIsCurrentUserDeviationAuthor } from '../../utils/hooks/useIsCurrentUserDeviationAuthor';
import { useDeviationAttributes } from '../../DeviationViews/hooks/useDeviationAttributes';
import FaveButton from '../../FaveButton';
import FavingIcon from '../../FaveButton/FavingIcon';

import s from './FaveControl.scss';

export interface Props {
  deviation: PapiDeviation;
  className?: string;
  displayClassName?: string;
  'aria-label'?: string;
}

const FaveControl: React.FC<Props> = ({
  deviation,
  className,
  displayClassName,
  'aria-label': ariaLabel,
}) => {
  const isOwner = useIsCurrentUserDeviationAuthor(deviation);
  const { isFavouritable } = useDeviationAttributes(deviation, isOwner);

  const iconAndTextRenderFn = ({ isFavourite, faveCount }) => (
    <div className={displayClassName}>
      <FavingIcon
        deviationId={deviation.deviationId}
        isFavourited={isFavourite}
        size={IconSize.SMALL}
        withPadding={false}
        disableDefaultColors={true}
        aria-label={ariaLabel}
      />
      <span>{faveCount}</span>
    </div>
  );

  return isFavouritable ? (
    <FaveButton
      className={classnames(s['button'], className)}
      deviation={deviation}
    >
      {iconAndTextRenderFn}
    </FaveButton>
  ) : (
    iconAndTextRenderFn({
      isFavourite: false,
      faveCount: deviation.stats?.favourites || 0,
    })
  );
};
FaveControl.displayName = 'FaveControl';

export default FaveControl;
